import { render, staticRenderFns } from "./DemoTokenTile.vue?vue&type=template&id=220241ac&scoped=true"
import script from "./DemoTokenTile.vue?vue&type=script&lang=js"
export * from "./DemoTokenTile.vue?vue&type=script&lang=js"
import style0 from "./DemoTokenTile.vue?vue&type=style&index=0&id=220241ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220241ac",
  null
  
)

export default component.exports